<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaProfissionals"
        title-table="Profissionais"
        module="professionsAtendimentoSettingsModule"
        sort-name="registro"
        :show-btn-add="verificarPermissao('ROLE_ATEND_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_ATEND_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <FormProfissional v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import { verificarPermissao } from '@/auth/utils'
import FormProfissional from './forms/FormProfissional.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormProfissional
  },
  computed: {
    ...mapState('professionsAtendimentoSettingsModule', {
      listaProfissionals: (state) => state.listaProfissionals
    })
  },
  data() {
    return {
      verificarPermissao,
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id'
        },
        {
          label: 'Nº Registro',
          field: 'numeroRegistroProfissional'
        },
        {
          label: 'Nome',
          field: 'registro.nome'
        },
        {
          label: 'Conselho',
          field: 'conselho.descricao'
        },
        {
          label: 'Ativo',
          field: 'ativo'
        },
        {
          label: 'Action',
          field: 'action'
        }
      ],
      pageConfig: {
        page: 1,
        size: 10,
        sort: 'nome',
        order: 'asc'
      }
    }
  },
  methods: {
    addNew() {
      this.showForm = true
      this.$store.dispatch('professionsAtendimentoSettingsModule/resetObject')
    },
    edit(data) {
      this.$store
        .dispatch('professionsAtendimentoSettingsModule/getById', data.id)
        .then((response) => {
          const obj = JSON.parse(JSON.stringify(response.data))
          obj.especialidades = response.data.especialidades.map((item) => {
            return { value: item.id, nome: item.descricao }
          })
          this.$store.dispatch(
            'professionsAtendimentoSettingsModule/prepareToEditProfissional',
            obj
          )
        })
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    }
  }
}
</script>
